module.exports = __webpack_public_path__ + "static/media/arrowleft.8a27d282.svg";